import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { StringRequest } from "../../services/StringRequest";
import { SysAdminService } from "../../services/sysadmin.service";
import { AppItemInfo } from "./AppItemInfo";
import { CreateRoleRequestModel } from "./CreateRoleRequestModel";
import { ManageApplicationItemsComponent } from "./manage-application-items/manage-application-items.component";
import { ManageReportsComponent } from "./manage-reports/manage-reports.component";

@Component({
	selector: "app-role-admin-add-role",
	templateUrl: "./role-admin-add-role.component.html",
	styleUrls: ["./role-admin-add-role.component.css"],
})
export class RoleAdminAddRoleComponent implements OnInit {
	constructor(
		private userService: UserService,
		private sysAdminService: SysAdminService,
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get data from DB
		this.loadUserLevels();
	}

	//////////////////////////////////////////
	// Data
	//////////////////////////////////////////
	user: any;

	//Get data from children
	@ViewChild(ManageApplicationItemsComponent)
	appItemComp: ManageApplicationItemsComponent;

	@ViewChild(ManageReportsComponent)
	reportItemComp: ManageReportsComponent;

	//Data From Parent
	SchoolID: any = 0;

	//Form Data
	RoleName: any = "";
	RoleDesc: any = "";
	SelectedUserLevel: any;
	AllSchools: any = false;

	lstUserLevels: any = [];

	AppItemData: any = null;
	ReportData: any = null;

	errorMessage: any = "";

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////

	loadUserLevels() {
		var result = this.sysAdminService.UserLevelGetList();
		result.subscribe(
			(response) => {
				this.lstUserLevels = response;
				this.SelectedUserLevel = this.lstUserLevels[0].UserLevelID;
			},
			(error) => {}
		);
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		//Error Handling
		if (this.RoleName == "") {
			this.errorMessage = "Enter a Role Name";
			return;
		}
		if (this.RoleDesc == "") {
			this.errorMessage = "Enter a Role Description";
			return;
		}

		//Check if name is used
		//Check if desc is used
		this.CheckName();
	}

	CheckName() {
		let parms: StringRequest = {
			str: this.RoleName,
		};

		var result = this.sysAdminService.RoleNameUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Role Name already in use";
					return;
				} else {
					//Check if desc is used
					this.CheckDesc();
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: StringRequest = {
			str: this.RoleDesc,
		};

		var result = this.sysAdminService.RoleDescUsed(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Role Description already in use";
					return;
				} else {
					//Check if desc is used
					this.CreateRole();
				}
			},
			(error) => {}
		);
	}

	CreateRole() {
		//Get data from children
		this.AppItemData = this.appItemComp.TreeItems;
		this.ReportData = this.reportItemComp.TreeItems;

		//Create request data
		var FormattedAppItems: AppItemInfo[] = [];
		var FormattedReportItems: AppItemInfo[] = [];

		//App Items
		for (var i = 0; i < this.AppItemData.length; i++) {
			var next = this.AppItemData[i];

			//
			// Check parent if child is checked (Otherwise category won't show up)
			//
			this.ParentCheckChild(next);

			var nextAppItem: AppItemInfo = {
				ApplicationItemID: next.data.ApplicationItemID,
				ApplicationItemKey: next.data.ApplicationItemKey,
				ApplicationItemName: next.data.ApplicationItemName,
				Access: next.data.Access == true ? 1 : 0,
				AccessRead: next.data.AccessRead == true ? 1 : 0,
				AccessUpdate: next.data.AccessUpdate == true ? 1 : 0,
				AccessInsert: next.data.AccessInsert == true ? 1 : 0,
				AccessDelete: next.data.AccessDelete == true ? 1 : 0,
				ReportID: -1,
			};

			FormattedAppItems = [...FormattedAppItems, nextAppItem];

			if (next.children != undefined) {
				for (var x = 0; x < next.children.length; x++) {
					var child = next.children[x];

					var nextAppItem: AppItemInfo = {
						ApplicationItemID: child.data.ApplicationItemID,
						ApplicationItemKey: child.data.ApplicationItemKey,
						ApplicationItemName: child.data.ApplicationItemName,
						Access: child.data.Access == true ? 1 : 0,
						AccessRead: child.data.AccessRead == true ? 1 : 0,
						AccessUpdate: child.data.AccessUpdate == true ? 1 : 0,
						AccessInsert: child.data.AccessInsert == true ? 1 : 0,
						AccessDelete: child.data.AccessDelete == true ? 1 : 0,
						ReportID: -1,
					};

					FormattedAppItems = [...FormattedAppItems, nextAppItem];

					if (child.children != undefined) {
						for (var z = 0; z < child.children.length; z++) {
							var subChild = child.children[z];

							var nextAppItem: AppItemInfo = {
								ApplicationItemID: subChild.data.ApplicationItemID,
								ApplicationItemKey: subChild.data.ApplicationItemKey,
								ApplicationItemName: subChild.data.ApplicationItemName,
								Access: subChild.data.Access == true ? 1 : 0,
								AccessRead: subChild.data.AccessRead == true ? 1 : 0,
								AccessUpdate: subChild.data.AccessUpdate == true ? 1 : 0,
								AccessInsert: subChild.data.AccessInsert == true ? 1 : 0,
								AccessDelete: subChild.data.AccessDelete == true ? 1 : 0,
								ReportID: -1,
							};

							FormattedAppItems = [...FormattedAppItems, nextAppItem];
						}
					}
				}
			}
		}

		//Report Items
		for (var i = 0; i < this.ReportData.length; i++) {
			var next = this.ReportData[i];

			var nextAppItem: AppItemInfo = {
				ApplicationItemID: next.data.ApplicationItemID,
				ApplicationItemKey: next.data.ApplicationItemKey,
				ApplicationItemName: next.data.ApplicationItemName,
				Access: next.data.Access == true ? 1 : 0,
				AccessRead: next.data.AccessRead == true ? 1 : 0,
				AccessUpdate: next.data.AccessUpdate == true ? 1 : 0,
				AccessInsert: next.data.AccessInsert == true ? 1 : 0,
				AccessDelete: next.data.AccessDelete == true ? 1 : 0,
				ReportID: next.data.ReportID,
			};

			FormattedReportItems = [...FormattedReportItems, nextAppItem];

			if (next.children != undefined) {
				for (var x = 0; x < next.children.length; x++) {
					var child = next.children[x];

					var nextAppItem: AppItemInfo = {
						ApplicationItemID: child.data.ApplicationItemID,
						ApplicationItemKey: child.data.ApplicationItemKey,
						ApplicationItemName: child.data.ApplicationItemName,
						Access: child.data.Access == true ? 1 : 0,
						AccessRead: child.data.AccessRead == true ? 1 : 0,
						AccessUpdate: child.data.AccessUpdate == true ? 1 : 0,
						AccessInsert: child.data.AccessInsert == true ? 1 : 0,
						AccessDelete: child.data.AccessDelete == true ? 1 : 0,
						ReportID: child.data.ReportID,
					};

					FormattedReportItems = [...FormattedReportItems, nextAppItem];

					if (child.children != undefined) {
						for (var z = 0; z < child.children.length; z++) {
							var subChild = child.children[z];

							var nextAppItem: AppItemInfo = {
								ApplicationItemID: subChild.data.ApplicationItemID,
								ApplicationItemKey: subChild.data.ApplicationItemKey,
								ApplicationItemName: subChild.data.ApplicationItemName,
								Access: subChild.data.Access == true ? 1 : 0,
								AccessRead: subChild.data.AccessRead == true ? 1 : 0,
								AccessUpdate: subChild.data.AccessUpdate == true ? 1 : 0,
								AccessInsert: subChild.data.AccessInsert == true ? 1 : 0,
								AccessDelete: subChild.data.AccessDelete == true ? 1 : 0,
								ReportID: subChild.data.ReportID,
							};

							FormattedReportItems = [...FormattedReportItems, nextAppItem];
						}
					}
				}
			}
		}

		var parms: CreateRoleRequestModel = {
			RoleName: this.RoleName,
			RoleDesc: this.RoleDesc,
			UserLevelID: this.SelectedUserLevel,
			SchoolID: this.SchoolID,
			AllSchools: this.AllSchools == true ? 1 : 0,
			ApplicationItems: FormattedAppItems,
			Reports: FormattedReportItems,
			DefinedByID: this.user.UserLevelID == 1 ? 4 : 3,
		};

		//Call SP
		var result = this.sysAdminService.CreateRole(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "AddRole",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Role was created successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "AddRole",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not create the Role",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	ParentCheckChild(ParentNode) {
		var Access: any = false;
		var Insert: any = false;
		var Update: any = false;
		var Delete: any = false;

		if (ParentNode.children != undefined) {
			for (var i = 0; i < ParentNode.children.length; i++) {
				var nextChild = ParentNode.children[i];

				if (nextChild.data.AccessRead == true) {
					Access = true;
				}
				if (nextChild.data.AccessInsert == true) {
					Insert = true;
				}
				if (nextChild.data.AccessUpdate == true) {
					Update = true;
				}
				if (nextChild.data.AccessDelete == true) {
					Delete = true;
				}

				if (nextChild.children != undefined) {
					for (var z = 0; z < nextChild.children.length; z++) {
						var nextInnerChild = nextChild.children[z];

						if (nextInnerChild.data.AccessRead == true) {
							Access = true;
						}
						if (nextInnerChild.data.AccessInsert == true) {
							Insert = true;
						}
						if (nextInnerChild.data.AccessUpdate == true) {
							Update = true;
						}
						if (nextInnerChild.data.AccessDelete == true) {
							Delete = true;
						}
					}
				}
			}
		}

		if (ParentNode.data.AccessRead == false) {
			ParentNode.data.AccessRead = Access;
		}
		if (ParentNode.data.AccessInsert == false) {
			ParentNode.data.AccessInsert = Insert;
		}
		if (ParentNode.data.AccessUpdate == false) {
			ParentNode.data.AccessUpdate = Update;
		}
		if (ParentNode.data.AccessDelete == false) {
			ParentNode.data.AccessDelete = Delete;
		}
	}

	//////////////////////////////////////////

	//////////////////////////////////////////
	// Events
	//////////////////////////////////////////

	//////////////////////////////////////////
}
